import React, { useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

import GetNiveles from "../../../data/GetNiveles";
import GetAsignaturas from "../../../data/GetAsignaturas";
import type { FormattedAsignatura } from "../../../interfaces/ObjetivosAprendizaje/iAsignaturas";
import TabsObjetivos from "../../TabPanel/TabsObjetivos";
import ObjetivesHelp from "../../Form/Indications/ObjetivesHelp";
import { useProyecto } from "../../../data/ProyectoContext";




type GetNivelesProps = React.ComponentProps<typeof GetNiveles>;

export interface CurriculumNacionalABPPanelProps {
  nivelId: GetNivelesProps["selectedNivel"];
  handleNivelChangeABP: GetNivelesProps["onNivelChange"];

  selectedAsignatura: FormattedAsignatura | null;
  setSelectedAsignatura: React.Dispatch<
    React.SetStateAction<FormattedAsignatura | null>
  >;

  handleAsignaturaChangeLocalABP: (asignatura: FormattedAsignatura) => void;

  promptData: any;
  setPromptData: React.Dispatch<React.SetStateAction<any>>;

  objetivosSeleccionados: any;
  setObjetivosSeleccionados: React.Dispatch<React.SetStateAction<any>>;
  setIsOAAdded: React.Dispatch<React.SetStateAction<boolean>>;
}

const CurriculumNacionalABPPanel: React.FC<CurriculumNacionalABPPanelProps> = ({
  nivelId,
  handleNivelChangeABP,
  selectedAsignatura,
  setSelectedAsignatura,
  handleAsignaturaChangeLocalABP,
  promptData,
  setPromptData,
  objetivosSeleccionados,
  setObjetivosSeleccionados,
  setIsOAAdded,
}) => {
  const [openObjetivesHelp, setOpenObjetivesHelp] = useState(false);
  const { proyecto } = useProyecto();
  const handleOpenObjetivesHelp = () => setOpenObjetivesHelp(true);
  const handleCloseObjetivesHelp = () => setOpenObjetivesHelp(false);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#1D3D4D",
          }}
        >
          ¿Qué objetivos de aprendizaje quieres trabajar?{" "}
          <Button sx={{ color: "#1D3D4D" }} onClick={handleOpenObjetivesHelp}>
            <HelpOutlineIcon />
          </Button>
        </Typography>
      </Grid>

      <ObjetivesHelp open={openObjetivesHelp} onClose={handleCloseObjetivesHelp} />

      <Grid item xs={12}>
        <Grid container spacing={2} alignItems="stretch">
          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 2, mt: 1 }}>
            <GetNiveles
              onNivelChange={handleNivelChangeABP}
              selectedNivel={nivelId}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={6} sx={{ mb: 2, mt: 1 }}>
            <GetAsignaturas
              nivelId={nivelId}
              onAsignaturaChange={(asignatura: FormattedAsignatura) => {
                setSelectedAsignatura(asignatura);
                handleAsignaturaChangeLocalABP(asignatura);
              }}
              selectedAsignatura={selectedAsignatura ? selectedAsignatura.id : ""}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <TabsObjetivos
          nombreNivel={proyecto.nivel_curso_cn}
          asignaturaSeleccionada={selectedAsignatura}
          setPromptData={setPromptData}
          objetivosSeleccionados={objetivosSeleccionados}
          setObjetivosSeleccionados={setObjetivosSeleccionados}
          setIsOAAdded={setIsOAAdded}
        />
      </Grid>
    </Grid>
  );
};

export default CurriculumNacionalABPPanel;
